export default __webpack_public_path__ + "static/media/JOSA CLASS-6 EXAM PATTERN 2025.3685ae57.pdf";